export const LOGGED_IN_SUCCESSFULLY = "LOGGED_IN_SUCCESSFULLY";
export const CURRENT_USER_LOGIN_DETAIL = "CURRENT_USER_LOGIN_DETAIL";
export const SET_APP_SETTINGS = "SET_APP_SETTINGS";
export const SET_USER_ROLE = "SET_USER_ROLE";